<template>
  <v-tooltip
    bottom
    v-if="mostrar"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        flat
        small
        :color="color"
        class="mx-0"
        @click="accion(itemSeleccionado)"
        v-on="on"
      >
        <v-icon
          small
          :class="clase"
        >{{icono}}</v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FacturacionCentroListadoProcesoFPPami',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tooltip: '',
      color: '',
      icono: '',
      clase: '',
      mostrar: false,
      itemSeleccionado: this.item,
      puedeProcesar: false
    }
  },
  mounted () {
    this.controlar()
  },
  methods: {
    controlar () {
      let vm = this
      vm.mostrar = true
      vm.icono = 'autorenew'
      vm.clase = ''
      vm.puedeProcesar = false
      switch (vm.itemSeleccionado.estado_facturacion.codigo) {
        case 'abierto':
          vm.color = vm.itemSeleccionado.procesado ? 'green darken-1' : 'deep-orange darken-1'
          vm.tooltip = vm.itemSeleccionado.procesado ? 'Procesado' : 'Debe procesar'
          vm.puedeProcesar = true
          break
        case 'en_proceso':
          vm.color = 'yellow darken-1'
          vm.clase = 'rotating'
          vm.tooltip = 'Procesando'
          break
        case 'error':
          vm.icono = 'error'
          vm.color = 'deep-orange darken-1'
          vm.tooltip = 'Error!'
          vm.puedeProcesar = false
          break
        default:
          vm.mostrar = false
          break
      }
    },
    accion () {
      if (this.puedeProcesar) {
        this.$emit('procesar', this.item)
      }
    }
  },
  watch: {
    'item.estado_facturacion.codigo' (codigo) {
      this.itemSeleccionado.estado_facturacion.codigo = codigo
      this.itemSeleccionado.procesado = true
      this.controlar()
    },
    'item.procesado' (valor) {
      this.itemSeleccionado.procesado = valor
      this.controlar()
    }
  }
}
</script>

<style lang="scss" scoped>
.rotating {
  -webkit-animation-name: spin;
  -webkit-animation-duration: 1000ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: spin;
  -moz-animation-duration: 1000ms;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  -ms-animation-name: spin;
  -ms-animation-duration: 1000ms;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: linear;

  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@-ms-keyframes spin {
  from {
    -ms-transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
  }
}
@-moz-keyframes spin {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
